
export default () => {
    document.addEventListener('DOMContentLoaded', function () {

        document.querySelectorAll('.product-detail .variations select').forEach(select => {
      
          const wrapper = document.createElement('div');
          wrapper.className = 'variation-radios';
      
          [...select.options].forEach(option => {
            if (!option.value) return;
      
            const label = document.createElement('label');
            const input = document.createElement('input');
            const span  = document.createElement('span');
      
            input.type = 'radio';
            input.name = select.name;
            input.value = option.value;
      
            // ✅ nếu option đang selected → check radio
            if (option.selected) {
              input.checked = true;
            }
      
            input.addEventListener('change', () => {
              select.value = option.value;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            });
      
            span.textContent = option.text;
      
            label.appendChild(input);
            label.appendChild(span);
            wrapper.appendChild(label);
          });
      
          select.after(wrapper);
      
          // ✅ khi Woo thay đổi select (auto select / reset)
          select.addEventListener('change', () => {
            wrapper.querySelectorAll('input').forEach(radio => {
              radio.checked = (radio.value === select.value);
            });
          });
        });
      
      });
      
      
}